import { api } from 'restaurantAdmin/api';

export interface MessagingTemplate {
  id: string;
  name: string;
  description: string;
  template: string;
  additionalContent: string | null;
}

export const getMessagingTemplates = async (restaurantId: string) =>
  await api.get<MessagingTemplate[]>(
    `/restaurants/${restaurantId}/messaging/templates`,
  );

export const updateMessagingTemplate = async (
  restaurantId: string,
  templateId: string | undefined,
  payload: Pick<MessagingTemplate, 'additionalContent'>,
) =>
  await api.put<MessagingTemplate>(
    `/restaurants/${restaurantId}/messaging/templates/${templateId}`,
    payload,
  );
